module.exports = __webpack_public_path__ + "assets/images/project/menu/indonesia-thumb.jpg?v=f54985f7";